import React from 'react';

import AuthForm from '../components/AuthForm';

function Login() {
  return <AuthForm />;
}

export default Login;
